import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { Button } from 'App/components'
import { EModalComponents } from 'App/containers'
import { showModalAction } from 'store'
import { ReactComponent as PlusIcon } from 'assets/icons/Plus.svg'

export type TUserProfileLicensesButtonProps = {
  disabled?: boolean
}

export const UserProfileLicensesButton = (props: TUserProfileLicensesButtonProps) => {
  const dispatch = useDispatch()

  const { t } = useTranslation()

  const { disabled, ...modalProps } = props

  const handleClick = () => {
    dispatch(
      showModalAction({
        modalProps,
        modalTitle: t('modal.userLicenses.title_add'),
        modalType: EModalComponents.LICENSE_DIALOG
      })
    )
  }

  return (
    <Button icon={<PlusIcon />} variant="text" disabled={disabled} onClick={handleClick}>
      {t('userProfile.licenses.addLicenseButton')}
    </Button>
  )
}
